// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"182":"79b748fb","751":"ac5915fb","891":"75666b8d","964":"a76c14b3"}[chunkId] || chunkId) + "." + {"26":"70bc77b8f508ff56","182":"c0f1040eae9650a9","751":"2b767449b6e6ae16","891":"14ab3d785eb6629a","964":"ff5bf0c615dfe4be","982":"26f9dbc961e00c77"}[chunkId] + ".js";
};